var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelloHelperMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#36F",
  d: "M6.924.978a1.6 1.6 0 0 1 2.152 0l1.252 1.138a1.6 1.6 0 0 0 .821.395l1.67.27a1.6 1.6 0 0 1 1.342 1.682l-.11 1.688c-.02.31.051.619.204.889l.83 1.473a1.6 1.6 0 0 1-.479 2.099l-1.387.967a1.6 1.6 0 0 0-.569.713l-.634 1.568a1.6 1.6 0 0 1-1.939.933l-1.621-.481a1.6 1.6 0 0 0-.912 0l-1.621.481a1.6 1.6 0 0 1-1.94-.933l-.633-1.568a1.6 1.6 0 0 0-.569-.713l-1.387-.967a1.6 1.6 0 0 1-.48-2.099l.831-1.473a1.6 1.6 0 0 0 .203-.889L1.84 4.463a1.6 1.6 0 0 1 1.342-1.682l1.67-.27a1.6 1.6 0 0 0 .821-.395z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11.202 5.6-1.2 5.181H8.31l-.401-2.23-.515 2.23H5.802L4.8 7.097l1.646-.385.323 2.206.46-2.389 1.345-.315.494 2.74.312-2.927z"
})));
export default SvgWelloHelperMark;